(() => {
  'use strict';

  const WEB_APP_URL = "https://script.google.com/macros/s/AKfycbx_3nuGKqixtb3YOzAH04RO9umvzX4vQv7wChEFXXCE4BKxkANbOokt4lHFpGiuooWV/exec";

  function normalizeLayawayId(value) {
    let id = String(value || "").trim().toUpperCase();
    id = id.replace(/\s+/g, "");
    if (/^#D\d+$/.test(id)) return id;
    if (/^D\d+$/.test(id)) return "#" + id;
    if (/^#\d+$/.test(id)) return "#D" + id.slice(1);
    if (/^\d+$/.test(id)) return "#D" + id;
    return id;
  }

  function escapeHTML(str) {
    if (str === null || str === undefined) return '';
    return String(str).replace(/[&<>'"]/g, tag => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    }[tag] || tag));
  }

  function el(tag, attributes = {}, children = []) {
    const element = document.createElement(tag);
    for (const [key, value] of Object.entries(attributes)) {
      if (key === 'style' && typeof value === 'object') {
        Object.assign(element.style, value);
      } else if (key === 'style' && typeof value === 'string') {
        element.style.cssText = value;
      } else if (key === 'className') {
        element.className = value;
      } else if (key === 'textContent') {
        element.textContent = value;
      } else if (key.startsWith('on') && typeof value === 'function') {
        element.addEventListener(key.substring(2).toLowerCase(), value);
      } else {
        element.setAttribute(key, value);
      }
    }
    children.forEach(child => {
      if (typeof child === 'string') {
        element.appendChild(document.createTextNode(child));
      } else if (child instanceof Node) {
        element.appendChild(child);
      }
    });
    return element;
  }

  function showLayawayError(message) {
    const errorBox = document.getElementById("layaway-error-msg");
    if (!errorBox) return;
    errorBox.textContent = message;
    errorBox.classList.remove("layaway-state-hidden");
  }

  function clearLayawayError() {
    const errorBox = document.getElementById("layaway-error-msg");
    if (!errorBox) return;
    errorBox.textContent = "";
    errorBox.classList.add("layaway-state-hidden");
  }

  function showLayawaySuccess(message) {
    const successBox = document.getElementById("layaway-success-msg");
    if (!successBox) return;
    successBox.textContent = message;
    successBox.classList.remove("layaway-state-hidden");
  }

  function clearLayawaySuccess() {
    const successBox = document.getElementById("layaway-success-msg");
    if (!successBox) return;
    successBox.textContent = "";
    successBox.classList.add("layaway-state-hidden");
  }

  async function postLayaway(payload) {
    const res = await fetch(WEB_APP_URL, {
      method: "POST",
      redirect: "follow",
      headers: { "Content-Type": "text/plain;charset=utf-8" },
      body: JSON.stringify(payload)
    });
    const json = await res.json();
    if (json.status === "error") throw new Error(json.message || "Request failed.");
    return json.data;
  }

  // === FLOW VIEW STATE SWITCHES ===
  const forgotIdLink = document.getElementById("forgot-id-link");
  const backToLookupLink = document.getElementById("back-to-lookup-link");
  const lookupStepDiv = document.getElementById("lookup-step");
  const forgotIdStepDiv = document.getElementById("forgot-id-step");
  const summaryStepDiv = document.getElementById("summary-step");

  if (forgotIdLink) {
    forgotIdLink.addEventListener("click", (e) => {
      e.preventDefault();
      clearLayawayError();
      clearLayawaySuccess();
      lookupStepDiv.classList.add("layaway-state-hidden");
      forgotIdStepDiv.classList.remove("layaway-state-hidden");
    });
  }

  if (backToLookupLink) {
    backToLookupLink.addEventListener("click", (e) => {
      e.preventDefault();
      clearLayawayError();
      clearLayawaySuccess();
      forgotIdStepDiv.classList.add("layaway-state-hidden");
      lookupStepDiv.classList.remove("layaway-state-hidden");
    });
  }

  // === FORGOT ID SUBMISSION SERVICE ===
  const forgotIdSubmitBtn = document.getElementById("forgot-id-submit-btn");
  if (forgotIdSubmitBtn) {
    forgotIdSubmitBtn.addEventListener("click", async function() {
      clearLayawayError();
      clearLayawaySuccess();
      const email = document.getElementById("forgot-email").value.trim().toLowerCase();

      if (!email) {
        showLayawayError("Please provide a valid email address.");
        return;
      }

      forgotIdSubmitBtn.disabled = true;
      const span = forgotIdSubmitBtn.querySelector('span');
      const originalText = span ? span.textContent : forgotIdSubmitBtn.textContent;
      if (span) span.textContent = "Sending email...";
      else forgotIdSubmitBtn.textContent = "Sending email...";

      try {
        await postLayaway({
          action: "recoverLayawayIds",
          email: email
        });
        showLayawaySuccess("If a matching account exists, an email containing your active Layaway ID history has been successfully sent.");
      } catch (err) {
        showLayawayError(err.message || "Failed to submit recovery request. Please try again.");
      } finally {
        const span = forgotIdSubmitBtn.querySelector('span');
        if (span) span.textContent = originalText;
        else forgotIdSubmitBtn.textContent = originalText;
        forgotIdSubmitBtn.disabled = false;
      }
    });
  }

  // === LOOKUP LOGIC (Detailed Product Presentation Matrix) ===
  const lookupBtn = document.getElementById("lookup-btn");
  const summaryContent = document.getElementById("summary-content");

  if (lookupBtn) {
    lookupBtn.addEventListener("click", async function() {
      clearLayawayError();
      clearLayawaySuccess();
      const layawayId = normalizeLayawayId(document.getElementById("portal-id").value);
      const email = document.getElementById("portal-email").value.trim().toLowerCase();

      if (!layawayId || !email) {
        showLayawayError("Please enter your Layaway ID and Email.");
        return;
      }

      lookupBtn.disabled = true;
      const span = lookupBtn.querySelector('span');
      const originalText = span ? span.textContent : lookupBtn.textContent;
      if (span) span.textContent = "Looking up...";
      else lookupBtn.textContent = "Looking up...";

      try {
        const data = await postLayaway({
          action: "lookupLayaway",
          layawayId: layawayId,
          email: email
        });

        // Build checkout-style inline image and product details header row using pure DOM manipulation
        summaryContent.textContent = ''; // clear safely

        const headerDiv = el('div', { className: 'summary-checkout-header', style: 'display: flex; align-items: center; gap: 1.5rem; margin-bottom: 2.5rem; background: rgba(var(--color-foreground), 0.02); padding: 1.2rem; border-radius: 8px; border: 1px solid rgba(var(--color-foreground), 0.06);' });

        if (data.productImage) {
          headerDiv.appendChild(
            el('div', { className: 'summary-image-wrapper', style: 'position: relative; flex-shrink: 0; width: 64px; height: 64px; border: 1px solid rgba(var(--color-foreground), 0.15); border-radius: 6px; display: flex; align-items: center; justify-content: center; overflow: hidden; background: none; box-shadow: none; padding: 0;' }, [
              el('img', { 
                src: data.productImage, 
                alt: data.productTitle || 'Layaway item', 
                className: 'summary-product-image', 
                style: 'width: 100%; height: 100%; object-fit: cover; border-radius: 0; display: block; margin: 0; padding: 0;', 
                loading: 'lazy' 
              })
            ])
          );
        } else {
          headerDiv.appendChild(
            el('div', { className: 'summary-image-wrapper', style: 'flex-shrink: 0; width: 64px; height: 64px; background: rgba(var(--color-foreground), 0.05); border-radius: 8px; border: 1px dashed rgba(var(--color-foreground), 0.2); display: flex; align-items: center; justify-content: center;' }, [
              el('span', { style: 'font-size: 2rem; opacity: 0.3;', textContent: '🎸' })
            ])
          );
        }

        const titleDiv = el('div', { className: 'summary-title-wrapper', style: 'flex-grow: 1; min-width: 0;' }, [
          el('h4', { style: 'margin: 0 0 0.3rem 0; font-size: 1.5rem; font-weight: 600; line-height: 1.3; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;', textContent: data.productTitle || 'N/A' }),
          el('div', { style: 'font-size: 1.2rem; opacity: 0.75; letter-spacing: 0.05rem; text-transform: uppercase;', textContent: 'ID: ' + data.layawayId })
        ]);
        headerDiv.appendChild(titleDiv);

        // Details Block
        const detailsDiv = el('div', { className: 'summary-details', style: 'display: flex; flex-direction: column; gap: 1rem; line-height: 1.5;' });

        const mkRow = (label, val, rowStyle = 'border-top: 1px solid rgba(var(--color-foreground), 0.08); padding-top: 0.8rem;', valStyle = 'float: right;') => 
          el('div', { style: rowStyle }, [ el('strong', { textContent: label }), el('span', { style: valStyle, textContent: val }) ]);

        detailsDiv.appendChild(mkRow('Total Price:', '$' + (data.price || data.totalPrice || '0.00')));
        detailsDiv.appendChild(mkRow('Fulfillment Method:', data.fulfillmentMethod === 'shipping' ? 'Ship to me' : 'Pick up in store', 'border:none; padding:0;', 'float: right; text-transform: capitalize;'));
        detailsDiv.appendChild(mkRow('Deposit Paid:', '$' + (data.depositAmount || '0.00'), 'border:none; padding:0;'));
        detailsDiv.appendChild(mkRow('Total Paid to Date:', '$' + (data.paid || '0.00'), 'border:none; padding:0;', 'float: right; color: #008000; font-weight: bold;'));
        
        detailsDiv.appendChild(mkRow('Remaining Balance Due:', '$' + (data.balance || '0.00'), 'background: rgba(var(--color-foreground), 0.04); padding: 0.8rem; border-radius: 4px; font-size: 1.6rem; margin-top: 0.5rem;', 'float: right; color: rgb(var(--color-error)); font-weight: bold;'));
        detailsDiv.appendChild(el('div', { style: 'font-size: 1.1rem; opacity: 0.7; text-align: right; margin-top: -0.5rem; margin-bottom: 0.5rem;', textContent: '*Amounts above exclude applicable taxes' }));

        if (data.estimatedShipping !== undefined) {
          detailsDiv.appendChild(mkRow('Estimated Shipping (Billed at final payoff):', '$' + data.estimatedShipping, 'border-top: 1px dashed rgba(var(--color-foreground), 0.1); padding-top: 0.8rem; font-size: 1.3rem;'));
        }

        const policyDiv = el('div', { style: 'margin-top: 1rem; padding: 1.2rem; background-color: rgba(var(--color-foreground), 0.03); border-left: 3px solid rgba(var(--color-foreground), 0.3); font-size: 1.25rem;' }, [
          el('strong', { style: 'display: block; margin-bottom: 0.4rem;', textContent: 'Shipping & Address Policy' }),
          'Your shipping address and fulfillment method were securely locked during the initial deposit to prevent tax jurisdiction drift. This exact address will be used for final delivery. Please ',
          el('a', { href: 'mailto:Layaway@guitarfinds.com', className: 'link', textContent: 'contact staff' }),
          ' immediately if you need to update it.'
        ]);
        detailsDiv.appendChild(policyDiv);

        detailsDiv.appendChild(mkRow('Layaway Expiration Date:', data.expirationDate || data.expiry || 'N/A', 'border-top: 1px solid rgba(var(--color-foreground), 0.08); padding-top: 0.8rem; font-size: 1.3rem; opacity: 0.85;', 'float: right; font-weight: bold;'));
        
        if (data.notes) {
          detailsDiv.appendChild(el('div', { style: 'font-size: 1.2rem; font-style: italic; margin-top: 0.5rem;', textContent: '*Account Memo: ' + data.notes }));
        }

        summaryContent.appendChild(headerDiv);
        summaryContent.appendChild(detailsDiv);

        lookupStepDiv.classList.add("layaway-state-hidden");
        summaryStepDiv.classList.remove("layaway-state-hidden");

        const contactBox = document.getElementById("layaway-contact-box");
        const rightColumn = document.getElementById("info-card-body");
        if (contactBox && rightColumn) {
          // Adjust vertical margin slightly so it has breathing room beneath the tiers list
          contactBox.style.marginTop = "3rem";
          rightColumn.appendChild(contactBox);
        }

      } catch (err) {
        showLayawayError(err.message || "No active layaway records found matching that ID and email combination.");
      } finally {
        const span = lookupBtn.querySelector('span');
        if (span) span.textContent = originalText;
        else lookupBtn.textContent = originalText;
        lookupBtn.disabled = false;
      }
    });
  }

  // === INSTALLMENT REDIRECT CODE PROCESSING EXECUTION ===
  const paymentBtn = document.getElementById("layaway-portal-btn");
  if (paymentBtn) {
    paymentBtn.addEventListener("click", async function() {
      clearLayawayError();
      const btn = this;
      const layawayId = normalizeLayawayId(document.getElementById("portal-id").value);
      const email = document.getElementById("portal-email").value.trim().toLowerCase();
      const amount = document.getElementById("portal-amount").value.trim();

      if (!layawayId || !email || !amount) {
        showLayawayError("Please enter a valid payment amount.");
        return;
      }
      if (Number(amount) <= 0) {
        showLayawayError("Payment amount must be greater than zero.");
        return;
      }

      try {
        btn.disabled = true;
        const span = btn.querySelector('span');
        const originalText = span ? span.textContent : btn.textContent;
        if (span) span.textContent = "GENERATING SECURE CHECKOUT...";
        else btn.textContent = "GENERATING SECURE CHECKOUT...";

        const data = await postLayaway({
          action: "processInstallment",
          layawayId: layawayId,
          email: email,
          amount: amount
        });

        if (!data || !data.checkoutUrl) throw new Error("No secure checkout session link was returned.");
        window.location.href = data.checkoutUrl;

      } catch (err) {
        showLayawayError(err.message || "Network transmission error. Please try again.");
        const span = btn.querySelector('span');
        if (span) span.textContent = "Generate Payment Link";
        else btn.textContent = "Generate Payment Link";
        btn.disabled = false;
      }
    });
  }

  // === SECURE CANCELLATION WORKFLOW (POST-LOOKUP CONTEXT) ===
  const cancelLink = document.getElementById("cancel-layaway-link");
  if (cancelLink) {
    cancelLink.addEventListener("click", async function(e) {
      e.preventDefault();
      clearLayawayError();
      const layawayId = normalizeLayawayId(document.getElementById("portal-id").value);
      const email = document.getElementById("portal-email").value.trim().toLowerCase();

      try {
        const preview = await postLayaway({
          action: "previewCancelLayaway",
          layawayId: layawayId,
          email: email
        });

        // Replace the summary content with a native inline cancellation review panel
        const summaryContent = document.getElementById("summary-content");
        const paymentStepDiv = document.getElementById("payment-step");
        
        if (paymentStepDiv) paymentStepDiv.classList.add("layaway-state-hidden");
        cancelLink.classList.add("layaway-state-hidden");

        // Build cancellation panel natively
        summaryContent.textContent = '';
        
        const wrapDiv = el('div', { style: 'background-color: rgba(var(--color-foreground), 0.02); border: 1px solid rgba(var(--color-foreground), 0.1); border-radius: 8px; padding: 2rem; margin-top: 1rem;' }, [
          el('h3', { style: 'color: #f12121ff; margin-top: 0; margin-bottom: 1.5rem; font-size: 2rem;', textContent: '⚠️ Confirm Cancellation' }),
          el('p', { style: 'margin-top: 0; color: #fbfbfbff;' }, [
            'You are requesting to permanently cancel Layaway ',
            el('strong', { textContent: preview.layawayId }),
            '.'
          ]),
          
          el('div', { style: 'background: rgba(255,255,255,0.7); border-radius: 4px; padding: 1.5rem; margin-bottom: 2rem; border: 1px dashed #fca5a5;' }, [
            el('div', { style: 'display: flex; justify-content: space-between; margin-bottom: 0.8rem; border-bottom: 1px solid rgba(0,0,0,0.05); padding-bottom: 0.8rem;' }, [
              el('span', { style: 'color: #451a03;', textContent: 'Total Paid to Date:' }),
              el('strong', { textContent: '$' + preview.paid })
            ]),
            el('div', { style: 'display: flex; justify-content: space-between; margin-bottom: 0.8rem; border-bottom: 1px solid rgba(0,0,0,0.05); padding-bottom: 0.8rem;' }, [
              el('span', { style: 'color: #451a03;', textContent: 'Non-Refundable Deposit:' }),
              el('strong', { style: 'color: #b91c1c;', textContent: '-$' + preview.depositAmount })
            ]),
            el('div', { style: 'display: flex; justify-content: space-between; font-size: 1.4rem;' }, [
              el('span', { style: 'color: #451a03; font-weight: 600;', textContent: 'Estimated Refund Balance:' }),
              el('strong', { style: 'color: #047857;', textContent: '$' + preview.refundableAmount })
            ])
          ]),

          el('p', { style: 'color: #fdfbfbff; font-size: 1.3rem; margin-bottom: 2rem; font-weight: 500;', textContent: 'By proceeding, your deposit is permanently forfeited and the instrument will be restocked into global inventory immediately.' }),

          el('div', { style: 'display: flex; gap: 1rem; flex-direction: column;' }, [
            el('button', { id: 'confirm-cancel-action-btn', type: 'button', className: 'button button--primary button--full-width', style: 'background-color: #dc2626; color: white; border: none;', textContent: 'Yes, Cancel Layaway' }),
            el('button', { id: 'abort-cancel-action-btn', type: 'button', className: 'button button--secondary button--full-width', textContent: 'Nevermind, Keep Layaway' })
          ])
        ]);

        summaryContent.appendChild(wrapDiv);

        // Bind new abort button to simply reload the view safely
        document.getElementById("abort-cancel-action-btn").addEventListener("click", () => {
          window.location.reload();
        });

        // Bind the final destructive action
        const finalCancelBtn = document.getElementById("confirm-cancel-action-btn");
        finalCancelBtn.addEventListener("click", async () => {
          finalCancelBtn.innerText = "Processing...";
          finalCancelBtn.disabled = true;
          document.getElementById("abort-cancel-action-btn").disabled = true;

          try {
            await postLayaway({
              action: "cancelLayaway",
              layawayId: layawayId,
              email: email,
              confirmCancel: true
            });

            summaryContent.textContent = '';
            summaryContent.appendChild(
              el('div', { style: 'background-color: #f0fdf4; border: 1px solid #4ade80; border-radius: 8px; padding: 2rem; margin-top: 1rem; text-align: center;' }, [
                el('h3', { style: 'color: #166534; margin-top: 0; margin-bottom: 1rem;', textContent: 'Cancellation Complete' }),
                el('p', { style: 'color: #14532d; margin-bottom: 0;', textContent: 'Your plan has been voided. A team member will audit the details shortly.' })
              ])
            );

          } catch (cancelErr) {
            showLayawayError(cancelErr.message || "Cancellation failed. Please contact support.");
            finalCancelBtn.innerText = "Yes, Cancel Layaway";
            finalCancelBtn.disabled = false;
            document.getElementById("abort-cancel-action-btn").disabled = false;
          }
        });

      } catch (err) {
        showLayawayError(err.message || "Unable to fetch cancellation preview data. Please try again.");
      }
    });
  }

})();
